import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MapIncomeToBusinessSegmentFormComponent } from './map-income-to-business-segment-form/map-income-to-business-segment-form.component';
import { CommonModule } from '@angular/common';

const routes: Routes = [
  {
      path:'',
      data:{
        title:'Map Income To Business Segment',
      },
      component:MapIncomeToBusinessSegmentFormComponent
    },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MapIncomeToBusinessSegmentRoutingModule { }
